// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-60ae0034] p a{--text-opacity:1;color:#ff9c4a;color:rgba(255,156,74,var(--text-opacity));transition-property:background-color,border-color,color,fill,stroke;transition-duration:.3s}[data-v-60ae0034] p a:hover{--text-opacity:1;color:#003597;color:rgba(0,53,151,var(--text-opacity))}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
